import React, { useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import Login from "./comp/login";
import Dash from "./comp/dash";
import { auth, firebaseConfigError } from "./firebaseClient";

export default function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [sessionError, setSessionError] = useState("");
  useEffect(() => {
    if (!auth) { setCheckingSession(false); return; }
    return onAuthStateChanged(auth, user => {
      setCurrentUser(user ? { id: user.uid, email: user.email, username: user.displayName || user.email } : null);
      setCheckingSession(false);
    }, () => {
      setSessionError("تعذر التحقق من جلسة الدخول. أعد تحميل الصفحة.");
      setCheckingSession(false);
    });
  }, []);
  const handleLogout = async () => {
    try { await signOut(auth); }
    catch (error) { window.alert("تعذر تسجيل الخروج. يرجى المحاولة مجددًا."); }
  };
  if (firebaseConfigError || sessionError || checkingSession) {
    return <div role="status" style={{ padding: 30, direction: "rtl", fontFamily: "sans-serif" }}>
      {firebaseConfigError || sessionError || "جاري التحقق من جلسة الدخول..."}
    </div>;
  }
  return currentUser ? <Dash key={currentUser.id} currentUser={currentUser} onLogout={handleLogout} /> : <Login />;
}
